import { Label } from "@/components/ui/label";
import { useTranslation } from "react-i18next";
import { useDescriptionListContext } from "./DescriptionListContext";
import { DescriptionProps } from "./types";
import ValueRenderer from "./DescriptionValue";
import { cn } from "@/lib/utils";

interface DescriptionItemProps extends DescriptionProps {
  className?: string;
  icon?: React.ElementType;
}

const DescriptionItem = ({
  name,
  renderer,
  className,
  icon: Icon,
}: DescriptionItemProps) => {
  const { t } = useTranslation();
  const { translationKey, data } = useDescriptionListContext();
  return (
    <div className={cn("flex flex-col gap-1", className)}>
      <Label className="text-sm font-medium">
        {t(`${translationKey}.fields.${name}`)}
      </Label>
      <span className="text-sm text-muted-foreground flex items-center gap-2">
        {Icon && <Icon className="w-4 h-4" />}
        <ValueRenderer value={data?.[name] as string} renderer={renderer} />
      </span>
    </div>
  );
};

export default DescriptionItem;
